import { render, staticRenderFns } from "./duplicateCandidate.vue?vue&type=template&id=bcdfaf1c&scoped=true"
import script from "./duplicateCandidate.vue?vue&type=script&lang=js"
export * from "./duplicateCandidate.vue?vue&type=script&lang=js"
import style0 from "./duplicateCandidate.vue?vue&type=style&index=0&id=bcdfaf1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdfaf1c",
  null
  
)

export default component.exports